(() => {

  const togglePassword = () => {
    document.querySelectorAll('.js-form-item.form-type-password').forEach((passwordField) => {
      const input = passwordField.querySelector('input.form-control');  
      const toggleButton = document.createElement('button');
      toggleButton.type = 'button';
      toggleButton.classList.add('toggle-visibility');
      toggleButton.setAttribute('aria-label', 'Show password');

      // Add the SVG icon inside the button
      toggleButton.innerHTML = `
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_12018_23439)">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1.43614 12.7243C1.4225 12.7074 1.44978 12.742 1.43614 12.7243C1.32944 12.5783 1.33213 12.4047 1.43662 12.2571C1.44427 12.2462 1.45207 12.235 1.45998 12.2235C4.59804 7.6421 8.48951 5.20508 12.5122 5.20508C16.5307 5.20508 20.4187 7.63554 23.5534 12.2078C23.6129 12.2945 23.6429 12.3837 23.6429 12.4904C23.6429 12.6023 23.608 12.6964 23.5454 12.7874C20.4116 17.351 16.5271 19.7765 12.5122 19.7765C8.47928 19.7765 4.57761 17.3279 1.43614 12.7243ZM3.8764 11.9358C3.61841 12.2565 3.61841 12.7241 3.87639 13.0449C6.56361 16.3859 9.58935 17.955 12.5122 17.955C15.4351 17.955 18.4609 16.3859 21.1481 13.0449C21.4061 12.7241 21.4061 12.2565 21.1481 11.9358C18.4609 8.59486 15.4351 7.02662 12.5122 7.02662C9.58935 7.02662 6.56361 8.59486 3.8764 11.9358Z"
                fill="#1443FF"/>
          <path class="slash" d="M3.06055 2.99072L22 21.9302" stroke="#1443FF" stroke-width="2" stroke-linecap="round"/>
          <circle cx="12.5" cy="12.4907" r="3" fill="#1443FF"/>
        </g>
        <defs>
          <clipPath id="clip0_12018_23439">
            <rect width="24" height="24" fill="white" transform="translate(0.5 0.490723)"/>
          </clipPath>
        </defs>
      </svg>
    `;

      // Append the button to the password field container
      passwordField.appendChild(toggleButton);

      // Add event listener to toggle visibility
      toggleButton.addEventListener('click', () => {
        const slashPath = toggleButton.querySelector('.slash');
        if (input.type === 'password') {
          input.type = 'text';
          slashPath.style.display = 'none'; // Hide the slash path
          toggleButton.setAttribute('aria-label', 'Hide password');
        } else {
          input.type = 'password';
          slashPath.style.display = 'block'; // Show the slash path
          toggleButton.setAttribute('aria-label', 'Show password');
        }
      });
    });
  };
  togglePassword();

  const addPasswordHintIcon = () => {
    // Select the password label
    const passwordLabel = document.querySelector(".js-form-item.form-type-password .form-label");

    // Check if the icon already exists
    if (passwordLabel && !passwordLabel.querySelector(".tooltip-icon")) {
      // Create the SVG element
      const infoIcon = document.createElement("span");
      infoIcon.classList.add("tooltip-icon"); // Add a class for styling
      infoIcon.innerHTML = `
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.89109 15.6909L8.89109 15.2126L8.96704 8.73187L11.0177 8.73187L11.0936 15.2126L11.0936 15.6909L8.89109 15.6909ZM9.99995 7.65175C9.30122 7.65175 8.79995 7.09626 8.79995 6.46362C8.79995 5.80012 9.30122 5.29092 9.99995 5.29092C10.6987 5.29092 11.2 5.80012 11.2 6.46362C11.2 7.09626 10.6987 7.65175 9.99995 7.65175Z"
          fill="#1443FF"/>
        <circle cx="10" cy="10.4907" r="9.16667" stroke="#1443FF" stroke-width="1.66667"/>
      </svg>
    `;

      // Append the icon to the label
      passwordLabel.appendChild(infoIcon);
    }
  }

  const togglePasswordHint = () => {
    addPasswordHintIcon();

    const icon = document.querySelector(".js-form-item.form-type-password .form-label .tooltip-icon");
    const tooltip = document.querySelector(".js-form-item.form-type-password .description");

    if (icon && tooltip) {
      tooltip.classList.add("hidden");

      // Toggle the tooltip on 'i' icon click
      icon.addEventListener("click", (event) => {
        event.stopPropagation();
        tooltip.classList.toggle("hidden");
      });

      // Global listener to close the tooltip when clicking outside
      // document.addEventListener("click", (event) => {
      //   if (!tooltip.contains(event.target) && event.target !== icon) {
      //     tooltip.classList.remove("hidden");
      //   }
      // });
    }
  }
  togglePasswordHint();


})();  
